import types from "./inputFileUpperTypes";
// import DocumentoService from '../../../api/DocumentoService';
import ModalErrorAction from '../../main/ModalErrorAction';
import { checkFileType, checkFileSize } from "../../../utils/FormatUtil";


export const cargarDocumentoAction = (file, id, fileType, fileSize, url, extension) => {
  return async dispatch => {
    try {
      dispatch({ type: types.ARCHIVO_CARGANDO, payload: { id } });
      if (checkFileType(fileType) && checkFileSize(fileSize, 5000000)) {
        dispatch({ type: types.ARCHIVO_CARGADO, payload: { file, id, url, extension } });
      } else if(!checkFileType(fileType)) {
        dispatch({ type: types.ARCHIVO_ERROR, payload: {id, error:"Formato no permitido. Los formatos permitidos son: PDF, JPG, PNG."} });
      } else if(!checkFileSize(fileSize, 5000000)){
        dispatch({ type: types.ARCHIVO_ERROR, payload: {id, error:"Tu archivo no puede superar 5 MB."} });
      }

    } catch (error) {
      dispatch({ type: types.ARCHIVO_ERROR, payload: {id, error:"¡Fallo, Intente de nuevo cargar archivo!"} });
      dispatch(ModalErrorAction(true));
    }
  };
};


/*
export const enviarDocumentoAction = (token, files, comentario) => {
  return async dispatch => {
    try {
      dispatch({ type: types.ARCHIVO_CARGANDO, payload: { enEjecucionAPIDatosPersona: true } });
      const respuestaDatosPersona = await DocumentoService.enviarDocumento(token, files, comentario);
      dispatch({ type: types.ARCHIVO_CARGADO, payload: { datosPersona: respuestaDatosPersona.data } });
    } catch (error) {
      dispatch({ type: types.ARCHIVO_ERROR, payload: error });
      dispatch(ModalErrorAction(true));
    }
  };
};

*/

export default cargarDocumentoAction;

